import { useEffect, useState } from 'react'

type IGetLangByCode = {
  locale: string
  language: string
  langLabel: string
  dir: 'ltr' | 'rtl'
  [index: string]: string
}

type ITheme = {
  readonly color: 'dark' | 'default'
  readonly lang: IGetLangByCode
  readonly loading: boolean
}

const INIT_STATE_THEME: ITheme = {
  color: 'default',
  lang: {
    locale: 'en-US',
    language: 'english',
    langLabel: 'en',
    dir: 'ltr',
  },
  loading: true,
}
type getLangByCode = (code: string) => void
type changeColor = (name: typeof INIT_STATE_THEME.color) => void

type IState = typeof INIT_STATE_THEME

export interface IUseTheme extends IState {
  readonly getLangByCode: getLangByCode
  readonly changeColor: changeColor
}

const useTheme = (): IUseTheme => {
  const [theme, setTheme] = useState<IState>(INIT_STATE_THEME)

  useEffect(() => {
    try {
      if (window.matchMedia) {
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
          changeColor(e.matches ? 'dark' : 'default')
        })
      }
    } catch (e) {}
    const theme = localStorage.getItem('theme')

    if (theme === 'dark' || theme === 'default') {
      changeColor(theme)
    } else {
      try {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          changeColor('dark')
        }
      } catch (e) {}
    }

    const lang = localStorage.getItem('lang')
    if (lang === 'en-US' || lang === 'fa-IR') {
      getLangByCode(lang)
    } else {
      getLangByCode('en-US')
    }
  }, [])
  const getLangByCode: getLangByCode = (code) => {
    setTheme((prevState) => ({
      ...prevState,
      loading: true,
    }))
    fetch(`${process.env.PUBLIC_URL}/langs/${code}.json`).then(async (obj: any) => {
      obj = await obj.json()
      document.documentElement.lang = obj['theme.locale']
      document.documentElement.dir = obj['dir']
      setTheme((prevState) => ({
        ...prevState,
        lang: obj,
        loading: false,
      }))
    })
  }

  const changeColor: changeColor = (name) => {
    document.body.setAttribute('data-theme', name)
    localStorage.setItem('theme', name)
    setTheme((prevState) => ({
      ...prevState,
      color: name,
    }))
  }

  return {
    ...theme,
    getLangByCode,
    changeColor,
  }
}
export default useTheme
